import { r as registerInstance, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsButtonCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-button{display:inline-block;transition:opacity 0.2s ease-in-out}.fds-button.fds-button--disabled{opacity:0.2;pointer-events:none}.fds-button.fds-button--disabled .fds-button__el{box-shadow:none}.fds-button.fds-button--block{display:block;width:100%}.fds-button.fds-button--block .fds-button__el{width:100%;justify-content:center}.fds-button__el{box-sizing:border-box;appearance:none;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;user-select:none;min-height:0;min-width:48px;height:48px;padding:0 1rem;margin:0;border-radius:8px;text-align:center;vertical-align:middle;white-space:nowrap;text-decoration:none;box-shadow:0 2px 4px rgba(12, 72, 153, 0.12);transition:box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;border:0;background-color:transparent;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:bold;font-size:1rem;line-height:1.25;letter-spacing:0}.fds-button__el>fds-spinner,.fds-button__el>fds-icon{margin-right:0.5rem}.fds-button--text-selectable .fds-button__el{user-select:text}.fds-button--icon-pos--right .fds-button__el>fds-icon{order:2;margin-left:0.5rem;margin-right:0}.fds-button--only-icon .fds-button__el>fds-spinner,.fds-button--only-icon .fds-button__el>fds-icon{margin-right:0}.fds-button--only-icon.fds-button--icon-pos--right .fds-button__el>fds-spinner,.fds-button--only-icon.fds-button--icon-pos--right .fds-button__el>fds-icon{margin-left:0}.fds-button--minor[loading] fds-icon,.fds-button--minor-invert[loading] fds-icon{display:none}.fds-button--minor .fds-button__el,.fds-button--minor-invert .fds-button__el{height:auto;border:0;box-shadow:none;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:normal;font-size:1rem;line-height:inherit;letter-spacing:inherit;color:#1D69C2;padding:0;background-color:rgba(255, 255, 255, 0);border-radius:4px;padding:2px;outline:none;word-break:break-word;white-space:normal;text-align:left}.fds-button--minor .fds-button__el>fds-icon,.fds-button--minor-invert .fds-button__el>fds-icon{vertical-align:middle;color:#3B87DD}.fds-button--minor .fds-button__el>fds-spinner,.fds-button--minor-invert .fds-button__el>fds-spinner{color:#3B87DD}.fds-button--minor .fds-button__el:hover,.fds-button--minor.fds-button--hover .fds-button__el,.fds-button--minor .fds-button__el:focus,.fds-button--minor.fds-button--focus .fds-button__el,.fds-button--minor-invert .fds-button__el:hover,.fds-button--minor-invert.fds-button--hover .fds-button__el,.fds-button--minor-invert .fds-button__el:focus,.fds-button--minor-invert.fds-button--focus .fds-button__el{background-color:rgba(12, 72, 153, 0.0475);text-decoration:none}.fds-button--minor .fds-button__el:active,.fds-button--minor.fds-button--active .fds-button__el,.fds-button--minor-invert .fds-button__el:active,.fds-button--minor-invert.fds-button--active .fds-button__el{background-color:rgba(12, 72, 153, 0.12)}.fds-button--minor.fds-button--size-s .fds-button__el,.fds-button--minor-invert.fds-button--size-s .fds-button__el{font-size:0.875rem}.fds-button--minor-invert .fds-button__el{color:white}.fds-button--minor-invert .fds-button__el>fds-icon{color:white}.fds-button--primary .fds-button__el{background-color:#E31C0D;border:1px solid #A41107;color:white}.fds-button--primary .fds-button__el:hover,.fds-button--primary.fds-button--hover .fds-button__el,.fds-button--primary .fds-button__el:focus,.fds-button--primary.fds-button--focus .fds-button__el{background-color:#A41107;border-color:#A41107;outline:none;text-decoration:none}.fds-button--primary .fds-button__el:active,.fds-button--primary.fds-button--active .fds-button__el,.fds-button--primary[loading] .fds-button__el{background-color:#750A03;border-color:#750A03;box-shadow:none}.fds-button--secondary .fds-button__el{background-color:white;border:2px solid #3B87DD;color:#1D69C2}.fds-button--secondary .fds-button__el:hover,.fds-button--secondary .fds-button__el:focus,.fds-button--secondary.fds-button--hover .fds-button__el,.fds-button--secondary.fds-button--focus .fds-button__el{background-color:white;border-color:#1D69C2;outline:none;text-decoration:none}.fds-button--secondary .fds-button__el:active,.fds-button--secondary.fds-button--active .fds-button__el,.fds-button--secondary[loading] .fds-button__el{background-color:#1D69C2;border-color:#1D69C2;color:white;box-shadow:none}.fds-button--primary.fds-button--size-s .fds-button__el,.fds-button--secondary.fds-button--size-s .fds-button__el{font-size:0.875rem;height:28px;padding:0 0.75rem}.fds-button--primary.fds-button--size-l .fds-button__el,.fds-button--secondary.fds-button--size-l .fds-button__el{font-size:1.125rem;height:68px;padding:0 1.5rem}";

const FdsButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.variant = 'secondary';
    this.loading = false;
    this.disabled = false;
    this.block = false;
    this.state = undefined;
    this.icon = undefined;
    this.iconPos = 'left';
    this.size = 'm';
    this.textSelection = false;
  }
  /**
   * Watch for the prop disabled and set corresponding attrubutes to the slotted element
   */
  watchDisabled() {
    this.handleDisabled();
  }
  /**
   * Watch for the prop loading and set corresponding attrubutes to the slotted element
   */
  watchLoading() {
    this.handleLoader();
  }
  /**
   * Watch for the prop icon and set corresponding attrubutes to the slotted element
   */
  watchIcon() {
    this.handleIcon();
  }
  componentWillLoad() {
    this.validateElement();
    // Set button classes to element in slot
    this.el.children[0].classList.add('fds-button__el');
    this.handleLoader();
    this.handleDisabled();
    this.handleIcon();
  }
  /**
   * Add `<fds-icon/>` to the button
   */
  handleIcon() {
    // Remove any old icon and refresh with a new
    if (this.el.children[0].children.length > 0) {
      for (let i = 0; i < this.el.children[0].children.length; i++) {
        if (this.el.children[0].children[i].tagName === 'FDS-ICON') {
          this.el.children[0].children[i].remove();
        }
      }
    }
    if (this.icon) {
      const icon = document.createElement('FDS-ICON');
      icon.setAttribute('name', this.icon);
      icon.setAttribute('size', '24px');
      this.el.children[0].insertBefore(icon, this.el.children[0].firstChild);
    }
  }
  /**
   * Handle the disable state of the slotted element.
   */
  handleDisabled() {
    if (this.disabled) {
      this.el.children[0].setAttribute('disabled', '');
    }
    else {
      this.el.children[0].removeAttribute('disabled');
    }
  }
  handleLoader() {
    if (this.loading) {
      this.addLoader();
    }
    else {
      this.removeLoader();
    }
  }
  /**
   * Add a spinner icon to button if the attribute `loading` is present.
   */
  addLoader() {
    // Remove any old icon and refresh with a new
    if (this.el.children[0].children.length > 0) {
      for (let i = 0; i < this.el.children[0].children.length; i++) {
        if (this.el.children[0].children[i].tagName === 'FDS-SPINNER') {
          this.el.children[0].children[i].remove();
        }
      }
    }
    const spinner = document.createElement('FDS-SPINNER');
    spinner.setAttribute('size', '24px');
    this.el.children[0].insertBefore(spinner, this.el.children[0].firstChild);
  }
  removeLoader() {
    const target = 'FDS-SPINNER';
    let i = 0;
    if (this.icon)
      i = 1;
    if (this.el.children[0].children[i] && this.el.children[0].children[i].tagName === target) {
      this.el.children[0].children[i].remove();
    }
  }
  /**
   * Validation of fds-button element
   * @rule 1. Must contain exactly 1 direct child element.
   * @rule 2. The direct child element must be either the tagName of BUTTON, INPUT or A.
   * @rule 3. If tagName is INPUT it can not have the props loading or icon due to it can't have child elements.
   */
  validateElement() {
    const children = this.el.children;
    /**
     * Rule 1
     */
    if (children.length !== 1) {
      const childTags = [];
      for (let i = 0; i < children.length; i++) {
        childTags.push(children[i].tagName);
      }
      console.error(`<fds-button>: Button can only contain exactly one direct child, found ${children.length}: [${childTags.join(', ')}].`);
    }
    /**
     * Rule 2
     */
    for (let i = 0; i < children.length; i++) {
      if (children[i].tagName !== 'BUTTON' &&
        children[i].tagName !== 'A' &&
        children[i].tagName !== 'INPUT') {
        console.error(`<fds-button>: Button can only contain a direct child of the tagName BUTTON, INPUT or A, found: ${children[i].tagName}`);
      }
    }
    /**
     * Rule 3
     */
    if (children[0].tagName === 'INPUT' && (this.loading || this.icon)) {
      console.error(`<fds-button>: Button with tagName 'INPUT' can have the props loading or icon due to it can't have any child element`);
    }
  }
  render() {
    let onlyIconOrSpinner = false;
    if (this.el.children[0].children.length > 0 &&
      (this.el.children[0].children[0].tagName === 'FDS-ICON' ||
        this.el.children[0].children[0].tagName === 'FDS-SPINNER')) {
      if (this.el.children[0].textContent === '') {
        onlyIconOrSpinner = true;
      }
    }
    const iconPos = (this.icon && this.iconPos) ? `fds-button--icon-pos--${this.iconPos}` : '';
    const classes = {
      'fds-button': true,
      [`fds-button--${this.variant}`]: true,
      [`fds-button--size-${this.size}`]: true,
      'fds-button--loading': this.loading,
      'fds-button--disabled': this.disabled,
      'fds-button--block': this.block,
      'fds-button--only-icon': onlyIconOrSpinner,
      'fds-button--text-selectable': this.textSelection,
      [`fds-button--${this.state}`]: this.state === 'active' || this.state === 'focus' || this.state === 'hover',
      [iconPos]: true,
    };
    return (h(Host, { class: classes, "aria-disabled": this.disabled ? 'true' : null }, h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "disabled": ["watchDisabled"],
    "loading": ["watchLoading"],
    "icon": ["watchIcon"]
  }; }
};
FdsButton.style = fdsButtonCss;

const fdsIconButtonCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}fds-icon-button{display:inline-flex}fds-icon-button[disabled]{pointer-events:none}.fds-icon-button{box-sizing:content-box;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;border-radius:0.25rem;border:0;background-color:rgba(255, 255, 255, 0);margin:0;transition:box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;user-select:none;appearance:none;outline:none;color:inherit;min-width:calc(1.5rem + 4px);min-height:calc(1.5rem + 4px);max-width:calc(1.5rem * 2);max-height:calc(1.5rem * 2);padding:2px;box-sizing:border-box}.fds-icon-button:hover,.fds-icon-button:focus,.fds-icon-button--hover,.fds-icon-button--focus{background-color:rgba(0, 0, 0, 0.7)}.fds-icon-button:active,.fds-icon-button--active{background-color:rgba(0, 0, 0, 0.12)}.fds-icon-button--bg-blue{color:#3B87DD}.fds-icon-button--bg-blue:hover,.fds-icon-button--bg-blue:focus,.fds-icon-button--bg-blue.fds-icon-button--hover,.fds-icon-button--bg-blue.fds-icon-button--focus{background-color:rgba(12, 72, 153, 0.0475)}.fds-icon-button--bg-blue:active,.fds-icon-button--bg-blue.fds-icon-button--active{background-color:rgba(12, 72, 153, 0.12)}.fds-icon-button--bg-blue fds-icon{width:1.5rem;height:1.5rem}.fds-icon-button--bg-red{color:#E31C0D}.fds-icon-button--bg-red:hover,.fds-icon-button--bg-red:focus,.fds-icon-button--bg-red.fds-icon-button--hover,.fds-icon-button--bg-red.fds-icon-button--focus{background-color:rgba(227, 28, 13, 0.07)}.fds-icon-button--bg-red:active,.fds-icon-button--bg-red.fds-icon-button--active{background-color:rgba(227, 28, 13, 0.15)}.fds-icon-button[disabled],.fds-icon-button--disabled{opacity:0.15;pointer-events:none}";

const FdsIconButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.icon = undefined;
    this.size = 48;
    this.state = undefined;
    this.disabled = false;
    this.color = 'black';
  }
  render() {
    const classes = {
      'fds-icon-button': true,
      'fds-icon-button--disabled': this.disabled,
      [`fds-icon-button--bg-${this.color}`]: true,
      [`fds-icon-button--${this.state}`]: this.state === 'active' || this.state === 'focus' || this.state === 'hover'
    };
    return (h("button", { class: classes, style: { 'width': `${this.size}px`, 'height': `${this.size}px` }, disabled: this.disabled, "aria-disabled": this.disabled ? 'true' : null }, h("fds-icon", { name: this.icon })));
  }
  get el() { return getElement(this); }
};
FdsIconButton.style = fdsIconButtonCss;

const fdsInputCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-input{display:block;margin-bottom:1rem}.fds-input .fds__label{cursor:pointer;display:block;display:inline-block;margin-bottom:0.25rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:bold;font-size:1rem;line-height:1.5;letter-spacing:0}.fds-input .fds__label--no-margin{margin-bottom:0}.fds-input--label-left{width:100%}@media screen and (min-width: 480px){.fds-input--label-left{display:grid;column-gap:1rem;grid-template-columns:auto 3fr;grid-template-rows:1fr min-content}}.fds-input .fds__hint{font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:lighter;font-size:1rem;line-height:1.335;letter-spacing:inherit;margin-bottom:0.25rem}.fds-input .error-msg{display:none;color:#E31C0D;line-height:1.5;font-size:1rem;margin-top:0.25rem;font-weight:bold}.fds-input .input__content{position:relative;display:flex;align-items:center}.fds-input .input__content .icon{position:absolute;user-select:none;display:none;justify-content:center;align-items:center;top:50%;right:0.75rem;transform:translateY(-50%);width:1.5rem;height:1.5rem}.fds-input .input__content .icon--password{display:inline-block;width:auto;height:auto}.fds-input .input__content__value{margin:0 0.5rem;text-align:right}.fds-input input[type=text],.fds-input input[type=number],.fds-input input[type=password],.fds-input input[type=search],.fds-input input[type=email],.fds-input input[type=date],.fds-input input[type=datetime-local],.fds-input input[type=tel]{box-sizing:border-box;display:block;width:100%;background-color:white;height:48px;padding:calc(0.75rem + 1px) 0.75rem;border-radius:4px;border:1px solid rgba(0, 0, 0, 0.4625);color:rgba(0, 0, 0, 0.795);outline:none;font-size:1rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;background-clip:padding-box}.fds-input input[type=date],.fds-input input[type=datetime-local]{line-height:initial;appearance:none;-webkit-appearance:none}.fds-input input[type=text]:focus,.fds-input input[type=number]:focus,.fds-input input[type=password]:focus,.fds-input input[type=search]:focus,.fds-input input[type=email]:focus,.fds-input input[type=date]:focus,.fds-input input[type=datetime-local]:focus,.fds-input input[type=tel]:focus{border:2px solid #3B87DD;padding:calc(0.75rem) calc(0.75rem - 1px)}.fds-input[valid=true] input[type=text],.fds-input[valid=true] input[type=number],.fds-input[valid=true] input[type=password],.fds-input[valid=true] input[type=search],.fds-input[valid=true] input[type=email],.fds-input[valid=true] input[type=date],.fds-input[valid=true] input[type=datetime-local],.fds-input[valid=true] input[type=tel]{padding-right:calc(2rem * 1.5)}.fds-input[valid=true] .icon{display:flex}.fds-input[valid=true] .icon svg{fill:#559C14}.fds-input[valid=false]:not(.optional) .error-msg{display:block}.fds-input[valid=false]:not(.optional) input[type=text],.fds-input[valid=false]:not(.optional) input[type=number],.fds-input[valid=false]:not(.optional) input[type=password],.fds-input[valid=false]:not(.optional) input[type=search],.fds-input[valid=false]:not(.optional) input[type=email],.fds-input[valid=false]:not(.optional) input[type=date],.fds-input[valid=false]:not(.optional) input[type=datetime-local],.fds-input[valid=false]:not(.optional) input[type=tel]{border:2px solid #E31C0D;padding-right:2.75rem}.fds-input[valid=false]:not(.optional) input[type=text]:focus,.fds-input[valid=false]:not(.optional) input[type=number]:focus,.fds-input[valid=false]:not(.optional) input[type=password]:focus,.fds-input[valid=false]:not(.optional) input[type=search]:focus,.fds-input[valid=false]:not(.optional) input[type=email]:focus,.fds-input[valid=false]:not(.optional) input[type=date]:focus,.fds-input[valid=false]:not(.optional) input[type=datetime-local]:focus,.fds-input[valid=false]:not(.optional) input[type=tel]:focus{border-color:#E31C0D;padding:calc(0.75rem + 1px) calc(2rem * 1.5) calc(0.75rem + 1px) calc(0.75rem)}.fds-input[valid=false]:not(.optional) .icon{display:flex}.fds-input[valid=false]:not(.optional) .icon svg{fill:#E31C0D}.fds-input[disabled]{cursor:not-allowed;pointer-events:none;opacity:0.2;user-select:none}.input__content--focus input[type=text],.input__content--focus input[type=number],.input__content--focus input[type=password],.input__content--focus input[type=search],.input__content--focus input[type=email],.input__content--focus input[type=date],.input__content--focus input[type=datetime-local],.input__content--focus input[type=tel]{border:2px solid #3B87DD;padding:calc(0.75rem) calc(0.75rem - 1px)}";

const FdsInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.state = 'none';
    this.label = undefined;
    this.meta = undefined;
    this.disabled = false;
    this.labelLeft = false;
    this.valid = undefined;
    this.showValue = false;
    this.postfixValue = undefined;
    this.invalidMessage = undefined;
    this.optional = false;
    this.passwordLabels = undefined;
    this.showPassword = false;
  }
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
    this.el.getElementsByTagName('input')[0].setAttribute('type', (this.showPassword ? 'text' : 'password'));
  }
  handleIcons() {
    if ((this.el.getElementsByTagName('input')[0].getAttribute('data-type') === 'password') && this.passwordLabels) {
      return (h("div", { class: "icon icon--password", onClick: () => this.toggleShowPassword() }, h("fds-button", { block: true, variant: "minor", icon: this.showPassword ? 'viewOff' : 'viewOn' }, h("button", { type: "button" }, this.showPassword ? this.passwordLabels.split(',')[1].trim() : this.passwordLabels.split(',')[0].trim()))));
    }
    else {
      // Valid can be ´true´, ´false´ and ´null´
      if (this.valid === 'true') {
        return h("div", { class: "icon" }, h("fds-icon", { name: "check", size: "24px" }));
      }
      else if (this.valid === 'false' && !this.optional) {
        return h("div", { class: "icon" }, h("fds-icon", { name: "alert", size: "24px" }));
      }
      else if (this.valid === 'null') {
        return '';
      }
    }
  }
  focusInput() {
    this.el.getElementsByTagName('input')[0].focus();
  }
  render() {
    const { label, meta, labelLeft, state } = this;
    const showInvalidMsg = (this.valid === 'false' && this.invalidMessage ? true : false);
    const inputEl = this.el.getElementsByTagName('input')[0];
    const inputId = inputEl.id;
    if (!inputId) {
      console.error(`Component [fds-input] requires an id.`);
    }
    if (this.label) {
      inputEl.setAttribute('aria-describedby', `aria-${inputId}`);
    }
    if (inputEl.getAttribute('type') === 'password') {
      inputEl.setAttribute('data-type', 'password');
    }
    function setLabelClasses() {
      const labelClasses = [
        'fds__label',
        (label && meta ? 'fds__label--no-margin' : null)
      ];
      return labelClasses.filter(val => val !== null).join(' ');
    }
    function setStateClass() {
      return state && state !== 'none' ? `input__content--${state}` : null;
    }
    return (h(Host, { "aria-disabled": this.disabled, class: `fds-input` + (labelLeft ? ' fds-input--label-left' : '') + (this.optional ? ' optional' : ' '), disabled: this.disabled }, h("div", null, this.label
      ? h("label", { id: `aria-${inputId}`, class: `${setLabelClasses()}`, htmlFor: inputId }, this.label)
      : null, this.meta
      ? h("div", { class: "fds__hint" }, this.meta)
      : null), h("div", { class: `input__content ${setStateClass()}` }, h("slot", null), this.handleIcons(), this.showValue
      ? h("span", { class: "input__content__value" }, h("slot", { name: "value" }), this.postfixValue ? this.postfixValue : null)
      : null), showInvalidMsg
      ? h("span", { class: "error-msg", "aria-live": "polite", id: `aria-${inputId}` }, this.invalidMessage)
      : null));
  }
  get el() { return getElement(this); }
};
FdsInput.style = fdsInputCss;

export { FdsButton as fds_button, FdsIconButton as fds_icon_button, FdsInput as fds_input };
